import { defineComponent } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import { SharedSearch } from "@/components/shared";
import { SvgAttribute } from "@/shared/constants/constants";
import { HistoryTab } from "@/shared/constants/enums";
import { HistoryFilterRequest, Search } from "@/shared/constants/interfaces";

export interface HistoryHeaderTab {
  id: number;
  label: string;
  value: HistoryTab;
  acitve: boolean;
  isDisabled: boolean;
}

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    SharedSearch,
  },
  emits: {
    refresh: null,
  },
  data() {
    return {
      isLoading: false,
      historyRepo: this.$projectServices.historyRepo,
    };
  },
  mounted(): void {
    this.positionPill();
    window.addEventListener("resize", this.positionPill);
  },
  beforeUnmount(): void {
    window.removeEventListener("resize", this.positionPill);
  },
  watch: {
    displayedTab(): void {
      this.$nextTick(this.positionPill);
    },
  },
  computed: {
    displayedTab(): HistoryTab {
      return this.historyRepo.tab;
    },

    displayedFilter(): HistoryFilterRequest {
      return this.historyRepo.filter;
    },

    displayedSearch(): Search {
      return this.historyRepo.search;
    },

    displayedTabs(): HistoryHeaderTab[] {
      return [
        {
          id: 0,
          label: "Пополнение/Вывод",
          value: HistoryTab.depositWithdrawal,
          acitve: this.displayedTab === HistoryTab.depositWithdrawal,
          isDisabled: this.isLoading,
        },
        {
          id: 1,
          label: "Заявки",
          value: HistoryTab.application,
          acitve: this.displayedTab === HistoryTab.application,
          isDisabled: this.isLoading,
        },
      ];
    },

    displayedIcons(): SvgAttribute {
      return SVG;
    },

    hasFilter(): boolean {
      const { date_from, date_to, status, currency_id, type, coin } =
        this.displayedFilter;

      return (
        !!date_from ||
        !!date_to ||
        !!status ||
        !!currency_id ||
        !!type ||
        !!coin
      );
    },

    isFilterOpen(): boolean {
      return this.historyRepo.isFilter;
    },
  },
  methods: {
    positionPill(): void {
      const pill = this.$refs.pill as HTMLElement | undefined;
      const buttons = this.$refs.tabButtons as HTMLButtonElement[] | undefined;

      if (!pill || !buttons?.length) return;

      const activeIndex = this.displayedTabs.findIndex((tab) => tab.acitve);
      const activeButton = buttons[activeIndex];

      if (!activeButton) return;

      pill.style.width = `${activeButton.offsetWidth}px`;
      pill.style.transform = `translateX(${
        activeButton.offsetLeft - pill.offsetLeft
      }px)`;
    },

    async handleTab({ value }: HistoryHeaderTab): Promise<void> {
      if (this.displayedTab === value) {
        return;
      }

      this.isLoading = true;
      this.historyRepo.CLEAR_PAGE();
      this.historyRepo.CLEAR_TYPE();
      this.historyRepo.UPDATE_TAB(value);

      this.$emit("refresh");
      this.isLoading = false;
    },

    handleFilter(): void {
      this.historyRepo.UPDATE_IS_FILTER(!this.historyRepo.isFilter);
    },

    handleClearFilter(): void {
      this.historyRepo.CLEAR_FILTER();
      this.$emit("refresh");
    },

    handleSearch(value: string): void {
      this.historyRepo.UPDATE_SEARCH_VALUE(value);
    },
  },
});
